export default {
    buttons: {
        0: [192, 50],
        1: [192, 50],
        2: [192, 50],
        3: [192, 50],
        4: [192, 50],
        5: [192, 50],
        6: [192, 50],
        7: [192, 50],
        8: [192, 50],
        9: [192, 50],
        10: [192, 50],
        11: [192, 50],
        12: [192, 50],
        13: [192, 50],
        14: [192, 50],
        15: [192, 50],
        16: [192, 50],
        17: [192, 50]
    }
}